<template>

    <div v-if=" currentItem != null ">

        <div class="quick-item-inner-wrap" >

            <div class="quick-item-hero-wrapper">

                <img class="quick-item-hero" :src=" currentItem.Image.name != null ? imageUrl + currentItem.Image.path + '/' + currentItem.Image.name : getLogoMerchantUrl( merchantSlug ) " @error="$event.target.src = '../../img/item.png'" alt=""/>
            </div>

            <div class="quick-item-main-wrapper">

                <div class="item-header">

                    <p>{{ currentItem.QuickItem.description }}</p>
                </div>

                <div class="order-detail-wrap">

                    <div class="order-item-price">

                        <h5>${{ itemPrice }}</h5>
                        <p v-if=" !allModifiersValid ">Please select required modifiers</p>
                    </div>

                    <div class="order-item-quantity">

                        <h5>quantity</h5>
                        <div class="number-input">

                            <button @click=" incrementDown() " ></button>
                            <input class="quantity" min="0" name="quantity" v-model=" currentItemDetails.quantity " type="number">
                            <button @click=" incrementUp() " class="plus"></button>
                        </div>

                        <button v-if=" !editingItem " :class=" orderButtonClass " type="button" @click=" addItem() " :disabled=" !allModifiersValid " >Add To Order</button>
                        <button v-else :class=" saveItemButtonClass " type="button" @click=" saveEditing() " :disabled=" !allModifiersValid " >Save Item</button>
                    </div>

                </div>
                <form>

                    <ModifierGroup></ModifierGroup>
                </form>
                <div class=" bottom-order-button " v-if=" relevantModifierGroups && relevantModifierGroups.length > 0 ">

                    <button v-if=" !editingItem " :class=" orderButtonClass " type="button" @click=" addItem() " :disabled=" !allModifiersValid " >Add To Order</button>
                    <button v-else :class=" saveItemButtonClass " type="button" @click=" saveEditing() " :disabled=" !allModifiersValid " >Save Item</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import ModifierGroup from '../misc/modifiers/ModifierGroup';

    export default {

        name: 'item',
        computed: {

            ...mapGetters({

                currentCategory         : 'orderMenu/currentCategory',
                currentItem             : 'orderMenu/currentItem',
                relevantModifierGroups  : 'orderMenu/relevantModifierGroups',
                editingItem             : 'orderMenu/editingItem',
                allModifiersValid       : 'orderMenu/allModifiersValid',
                currentItemDetails      : 'orderMenu/currentItemDetails',
                imageUrl                : 'imageUrl',
                merchantSlug            : 'merchant/merchantSlug',
                allMerchantsWithImages  : 'merchant/allMerchantsWithImages',
                currentLocation         : 'merchant/currentLocation',
                merchantIdCrocante      : 'merchantIdCrocante',
            }),
            itemPrice(){

                const relevantModifierGroups = this.relevantModifierGroups;

                const modifierPrice = this.currentItemDetails.modifiers.reduce( function ( total, value ) {

                    const modId = value.split( "_" )[ 3 ];
                    for( let modifierGroup of Object.values( relevantModifierGroups ) ) {

                        for( let aModifier of Object.values( modifierGroup.QuickModifier ) ) {

                            var newPrice = -1337;
                            if( aModifier.quickModifierId == modId ){

                                if( aModifier.price ){

                                    newPrice = total + parseFloat( aModifier.price );
                                    break;
                                }
                            }
                        }
                        if( newPrice != -1337 ){

                            total = newPrice;
                            break;
                        }
                    }
                    return total;
                }, 0 );

                return ( ( parseFloat( this.currentItem.QuickItem.unitPrice ) + modifierPrice ) * this.currentItemDetails.quantity ).toFixed( 2 );
            },
            orderButtonClass(){

                const base = [ 'order-button' ];
                base.push( this.currentLocation.merchantId == this.merchantIdCrocante ? 'button btn-brown' : 'button btn-blue' )
                return base.join( ' ' );
            },
            saveItemButtonClass(){

                const base = [ 'order-button' ];
                base.push( this.currentLocation.merchantId == this.merchantIdCrocante ? 'button btn-brown' : 'button btn-green' )
                return base.join( ' ' );
            }
        },
        methods: {

            ...mapActions({

                chooseCategory : 'orderMenu/chooseCategory'
            }),
            addItem(){

                if( this.allModifiersValid ){

                    var data = JSON.parse( JSON.stringify({ // hack to create a deep copy,
                        // could probably explore casting to array with Object.value then using spread operator

                        quickItemId : this.currentItem.QuickItem.quickItemId,
                        quantity    : this.currentItemDetails.quantity,
                        modifiers   : this.currentItemDetails.modifiers,
                        price       : this.itemPrice,
                        name        : this.currentItem.QuickItem.name,
                        taxRate     : this.currentItem.QuickItem.taxRate
                    }));
                    this.$store.dispatch( 'orderTab/addItem', data );
                } else {

                    console.log( 'not valid!' );
                }
            },
            saveEditing(){

                const data = JSON.parse( JSON.stringify({

                    id          : this.editingItem,
                    quickItemId : this.currentItem.QuickItem.quickItemId,
                    quantity    : this.currentItemDetails.quantity,
                    modifiers   : this.currentItemDetails.modifiers,
                    price       : this.itemPrice,
                    name        : this.currentItem.QuickItem.name,
                    taxRate     : this.currentItem.QuickItem.taxRate
                }));
                this.$store.dispatch( 'orderTab/saveEditing', data );
            },
            incrementDown(){

                this.$store.dispatch( 'orderMenu/updateCurrentItemDetails', 'decrement' );
            },
            incrementUp(){

                this.$store.dispatch( 'orderMenu/updateCurrentItemDetails', 'increment' );
            },
            exposeReq(){

                console.log( 'exposed!' );
            },
            getLogoMerchantUrl( slug ){
                var urlImagesFromStaticRealPayment = '';
                const merchantsLogos = this.allMerchantsWithImages;
                merchantsLogos.forEach( merchantLogo => {
                    if (merchantLogo.slug == slug) {
                        urlImagesFromStaticRealPayment = merchantLogo.imagePath + merchantLogo.imageName;
                    }     
                });
                
                return this.imageUrl + urlImagesFromStaticRealPayment
            }
        },
        components: {

            ModifierGroup
        }
    }

</script>

<style scoped>

    .order-detail-wrap {

        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
    }

    .back-button {

        color: black;
        margin: 0;
        font-size: 1.3rem;
        font-weight: bold;
        text-align: right;
        padding-right: 10px;
    }

    .quick-item-main-wrapper {

        background-color: #f5f5f5;
        padding-top: 15px;
    }

    .order-item-quantity {

        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding-right: 10px;
    }
    input[type=number] {

        -webkit-appearance: textfield;
    }
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {

        -webkit-appearance: none;
    }
    .number-input {

        border: 2px solid #ddd;
        display: inline-flex;
        margin: 5px auto;
    }
    .number-input,
    .number-input > * {

        box-sizing: border-box;
    }
    .number-input button {

        outline: none;
        -webkit-appearance: none;
        background-color: transparent;
        border: none;
        align-items: center;
        justify-content: center;
        width: 3rem;
        height: 3rem;
        cursor: pointer;
        margin: 0;
        position: relative;
    }
    .number-input button:before,
    .number-input button:after {

        display: inline-block;
        position: absolute;
        content: '';
        width: 1rem;
        height: 2px;
        background-color: #212121;
        transform: translate(-50%, -50%);
    }
    .number-input button.plus:after {

        transform: translate(-50%, -50%) rotate(90deg);
    }
    .number-input input[type=number] {

        font-family: sans-serif;
        max-width: 5rem;
        padding: .5rem;
        border: solid #ddd;
        border-width: 0 2px;
        font-size: 2rem;
        height: 3rem;
        font-weight: bold;
        text-align: center;
    }

    .order-item-quantity > h5 {

        margin: 0;
        text-align: center;
    }
    .order-item-price {

        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 15px;
    }
    .order-item-price > h5 {

        font-size: 2rem;
    }
    .order-item-price > p {

        color: red;
    }

    .order-item-price > * {

        margin: 0; padding: 0;
    }

    .item-header {

        display: flex;
        flex-direction: column;
        padding: 25px;
    }
    .item-header > p {

        text-align: justify;
        margin: 0;
    }
    .quick-item-inner-wrap {

        flex: 1;
    }
    .quick-item-hero-wrapper {

        text-align: center;
    }
    .quick-item-hero {

        max-width: 450px;
        max-height: 450px;
        width: 100%;
        height: 100%;
    }
    .quick-item-inner-wrap > form {

        width: 100%;
    }
    .order-button:disabled {

        background: linear-gradient(to bottom, #cbf1ff 5%, #87b2be 100%);
        cursor: not-allowed;
    }

    .bottom-order-button > button {

        width: 100%;
        height: 45px;
    }
</style>